<template>
  <div class="business-operate-record">
    <div class="module-item-style">
      <div class="module-item-title">操作记录</div>
      <tableBox
          class="record-table"
          :tableData="tableData"
          :tableHead="tableHead"
          :total="total"
          :size="pageSize"
          @pageHandler="pageOperate"></tableBox>
    </div>
  </div>
</template>

<script>
  import tableBox from '@/components/table/table'
  export default {
    name: 'business-operate-record',
    components:{
      tableBox
    },
    data() {
      return {
        tableData: [],
        tableHead: [
          {
            label: '版本名称',
            value: 'versionName',
            operate: false
          }, {
            label: '座席数',
            value: 'clientNum',
            operate: false,
          },{
            label: '子账号数',
            value: 'serviceNum',
            operate: false,
          },{
            label: '版本截止日期',
            value: 'deadTime',
            operate: false,
          }, {
            label: '版本使用日期',
            value: 'useTime',
            operate: false
          },{
            label: '上级版本名称',
            value: 'parentVerName',
            operate: false
          }, {
            label: '使用情况',
            value: 'useDetail',
            operate: false,
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    },
    created() {
      this.getOperateRecord()
    },
    mounted() {

    },
    methods: {
      /**
       * 分页操作
       * @param val
       */
      pageOperate(val){
        if(val.type == 'currentChange'){
          this.currentPage = val.val
        }else if(val.type == "sizeChange"){
          this.pageSize = val.val
        }
        this.getOperateRecord()
      },
      getOperateRecord(){
        let postData = {
          pageSize: this.pageSize,
          pageNum:this.currentPage
        }
        this.$http.getOperateRecordAPI(postData).then( res => {
          if(res.status == 1){
            this.tableData = res.data.logs
            this.total = res.data.total
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .business-operate-record{
    .record-table{
      margin-top: 20px;
    }
  }

</style>
